import Vue from 'vue';
import Router from 'vue-router';

import DashboardComponent from '@/views/dashboard/Dashboard.component.vue';
import LobbyComponent from '@/views/dashboard/lobby/Lobby.component.vue';
import MyFormsComponent from '@/views/dashboard/my-forms/MyForms.component.vue';
import ManagerComponent from '@/views/dashboard/manager/Manager.component.vue';
import Form101WizardComponent from '@/views/dashboard/form101/Form101Wizard.vue';
import SelectAuthMethodComponent from '@/views/authentication/select-auth-method/SelectAuthMethod.component.vue';
import LoginWithPasswordComponent from '@/views/authentication/login/LoginWithPassword.component.vue';
import LoginViaSmsComponent from '@/views/authentication/login/LoginViaSms.component.vue';
import ForgotPasswordComponent from '@/views/authentication/password/ForgotPassword.component.vue';
import PasswordExpiredComponent from '@/views/authentication/password/PasswordExpired.component.vue';
import EmailSentComponent from '@/views/authentication/login/success/EmailSent.component.vue';
import ResetPasswordComponent from '@/views/authentication/password/ResetPassword.component.vue';
import NotFound from '@/views/external-errors/NotFound.vue';
import Maintenance from '@/views/external-errors/Maintenance.vue';
import SearchEmployeesComponent from '@/views/dashboard/manager/search-employees/SearchEmployees.component.vue';
import StatsComponent from '@/views/dashboard/manager/statistics/Statistics.component.vue';
import UpdateEmpsDetails from '@/views/dashboard/manager/update-employees-details/UpdateEmployeesDetails.component.vue';
import CustomerDetailsComponent from '@/views/dashboard/manager/back-office/customer-details/CustomerDetails.component.vue';
import CustomersList from '@/views/dashboard/manager/back-office/CustomersList.vue';
import CubeDetailsComponent from '@/views/dashboard/manager/cube-details/CubeDetails.component.vue';
import SystemInfoLoginComponent from '@/views/system-info-login/SystemInfoLogin.component.vue';
import SystemInfoPageComponent from '@/views/system-info-page/SystemInfoPage.component.vue';
import BrowserCompatibilityComponent from '@/views/browser-compatibility/BrowserCompatibility.component.vue';
import LoginWithPasswordNoIndexComponent from '@/views/authentication/login/LoginWithPasswordNoIndex.component.vue';
import SystemCheckComponent from '@/components/system-check/system-check.component.vue';
import ApplicationUserComponent from '@/views/dashboard/manager/application-user/ApplicationUser.component.vue';
import ExportForms101Component from '@/views/dashboard/manager/export-forms-101/ExportForms101.component';
import InsurersReportsComponent from '@/views/dashboard/manager/insurers-reports/InsurersReports.component.vue';
import AdpFileControlComponent from '@/views/dashboard/manager/adp-file-control/AdpFileControl.component';
import OidcComponent from '@/views/authentication/oidc/oidc.component.vue';

const originalPush: any = Router.prototype.push;
Router.prototype.push = function push(location): Promise<any> {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: SelectAuthMethodComponent,
      meta: {
        authNotRequired: true,
        windowRedirectAfter: true,
        resetStore: true,
        hideHeaderAndMenu: true,
      },
      props: (route: any) => ({
        gov: route.query.c,
      }),
    },
    {
      path: '/password',
      name: 'password',
      component: LoginWithPasswordNoIndexComponent,
      meta: {
        authNotRequired: true,
        resetStore: true,
        hideHeaderAndMenu: true,
      },
      props: (route: any) => ({
        gov: route.query.c,
      }),
    },
    {
      path: '/password-no-index',
      name: 'passwordNoIndex',
      component: LoginWithPasswordComponent,
      meta: {
        authNotRequired: true,
        resetStore: true,
        hideHeaderAndMenu: true,
      },
      props: (route: any) => ({
        gov: route.query.c,
      }),
    },
    {
      path: '/sms',
      name: 'sms',
      component: LoginViaSmsComponent,
      meta: {
        authNotRequired: true,
        resetStore: true,
        hideHeaderAndMenu: true,
      },
      props: (route: any) => ({
        gov: route.query.c,
      }),
    },
    {
      path: '/browser-compatibility',
      name: 'browser-compatibility',
      component: BrowserCompatibilityComponent,
      meta: {
        authNotRequired: true,
        resetStore: true,
        hideHeaderAndMenu: true,
      },
    },
    {
      path: '/system-check',
      name: 'system-check',
      component: SystemCheckComponent,
      meta: {
        authNotRequired: true,
        resetStore: true,
        hideHeaderAndMenu: true,
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot',
      component: ForgotPasswordComponent,
      meta: {
        authNotRequired: true,
        hideHeaderAndMenu: true,
      },
      props: (route: any) => ({
        gov: route.query.c,
      }),
    },
    {
      path: '/expired-password',
      name: 'expired-password',
      component: PasswordExpiredComponent,
      props: true,
      meta: {
        authNotRequired: true,
        hideHeaderAndMenu: true,
      },
    },
    {
      path: '/email-sent',
      name: 'mail-sent',
      component: EmailSentComponent,
      meta: {
        authNotRequired: true,
        hideHeaderAndMenu: true,
      },
    },
    {
      path: '/pw',
      name: 'reset',
      component: ResetPasswordComponent,
      meta: {
        authNotRequired: true,
        hideHeaderAndMenu: true,
      },
      props: (route: any) => ({
        resetPwToken: route.query.t,
        indexNum: route.query.i,
      }),
    },
    {
      path: '/ssoLogin',
      name: 'ssoLogin',
      component: SelectAuthMethodComponent,
      meta: {
        authNotRequired: true,
        hideHeaderAndMenu: true,
      },
      props: (route: any) => ({
        ssoToken: route.query.t,
      }),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardComponent,
    },
    {
      path: '/lobby',
      name: 'lobby',
      component: LobbyComponent,
      meta: {
        showSupport: true,
      },
    },
    {
      path: '/my-forms',
      name: 'my-forms',
      component: MyFormsComponent,
    },
    {
      path: '/manager',
      name: 'manager',
      component: ManagerComponent,
    },
    {
      path: '/search-employees',
      name: 'search-employees',
      component: SearchEmployeesComponent,
      props: true,
    },
    {
      path: '/update-employees-details',
      name: 'update-employees-details',
      component: UpdateEmpsDetails,
    },
    {
      path: '/cube-details',
      name: 'cube-details',
      component: CubeDetailsComponent,
      props: true,
    },
    {
      path: '/stats',
      name: 'stats',
      component: StatsComponent,
    },
    {
      path: '/back-office/customers',
      name: 'all-customers',
      component: CustomersList,
    },
    {
      path: '/back-office/export-forms-101',
      name: 'export-forms-101',
      component: ExportForms101Component,
    },
    {
      path: '/back-office/insurers-reports',
      name: 'insurers-reports',
      component: InsurersReportsComponent,
    },
    {
      path: '/application-user',
      name: 'application-user',
      component: ApplicationUserComponent,
    },
    {
      path: '/back-office/adp-file-control',
      name: 'adp-file-control',
      component: AdpFileControlComponent,
    },
    {
      path: '/customer-details',
      name: 'customer-details',
      component: CustomerDetailsComponent,
    },
    {
      path: '/wizard',
      name: 'wizard',
      component: Form101WizardComponent,
      props: true,
      meta: {
        showSupport: true,
      },
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: Maintenance,
      meta: {
        authNotRequired: true,
        isMaintenance: true,
        resetStore: true,
        hideHeaderAndMenu: true,
      },
    },
    {
      path: '/system-info/login',
      name: 'system-info-login',
      component: SystemInfoLoginComponent,
      meta: {
        authNotRequired: true,
        resetStore: true,
        hideHeaderAndMenu: true,
        isSystemInfoPages: true,
      },
    },
    {
      path: '/system-info/page',
      name: 'system-info-page',
      component: SystemInfoPageComponent,
      meta: {
        hideHeaderAndMenu: true,
        isSystemInfoPages: true,
      },
    },
    {
      path: '/oidc/:id',
      name: 'oidc',
      component: OidcComponent,
      meta: {
        authNotRequired: true,
        resetStore: true,
        hideHeaderAndMenu: true,
      },
    },
    {
      path: '/oauth/callback',
      name: 'oidc-callback-login',
      component: SelectAuthMethodComponent,
      meta: {
        authNotRequired: true,
        hideHeaderAndMenu: true,
      },
      props: () => ({
        isOidcCallback: true,
      }),
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound,
      meta: {
        authNotRequired: true,
        isMaintenance: true,
        resetStore: true,
        hideHeaderAndMenu: true,
      },
    },
  ],
});

export default router;
